import { render, staticRenderFns } from "./DocumentRegisterer.vue?vue&type=template&id=0bd83e22&scoped=true&"
import script from "./DocumentRegisterer.vue?vue&type=script&lang=ts&"
export * from "./DocumentRegisterer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd83e22",
  null
  
)

export default component.exports